import { ServiceIcon, ServiceIconSize } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";

type Props = {
  serviceName: string;
  src: string;
  size: ServiceIconSize;
  hasBorder?: boolean;
  hasShadow?: boolean;
};

const SIZE_TO_PX: Record<string, number> = {
  "xx-small": 20,
  "x-small": 30,
  small: 40,
  medium: 60,
  large: 80,
};

function resolveHeightPx(size: ServiceIconSize): number {
  if (typeof size === "number") {
    return size;
  }
  return SIZE_TO_PX[size] ?? 40;
}

export default function ServiceIconWithFallback({
  serviceName,
  src,
  size,
  hasBorder = false,
  hasShadow = false,
}: Props) {
  if (serviceName && src) {
    return (
      <ServiceIcon
        alt={`${serviceName} icon`}
        hasBorder={hasBorder}
        size={size}
        hasShadow={hasShadow}
        serviceName={serviceName}
        src={src}
      />
    );
  }

  return (
    <div style={{ height: resolveHeightPx(size) }}>
      <Icon
        aria-hidden
        name="miscBolt"
        size={resolveHeightPx(size)}
        color="GrayWarm9"
      />
    </div>
  );
}
